const filters = ['desktopVersionDescribeE']
let dictionary

export const LocalizationService = {
  set,
  get,
}

function set(value) {
  dictionary = value
}

function get(text) {
  if(filters.includes(text)){
    return ''
  }

  return dictionary[text] || text
}
